import { Component, Input, EventEmitter, Output, OnInit, ViewChild, ElementRef, AfterContentChecked } from '@angular/core';

export enum RATING_TYPES {
  Star = 'Star',
  Number = 'Number',
}

export const DEFAULT_MAX_RATING = 5;
export const DEFAULT_RATING_TYPE = RATING_TYPES.Star;

@Component({
  selector: 'ey-display-rating',
  templateUrl: './ey-display-rating.component.html',
  styleUrls: ['./ey-display-rating.component.scss'],
})
export class EyDisplayRatingComponent implements OnInit, AfterContentChecked {
  @ViewChild('ratingTemplate') ratingTemplate: ElementRef;

  @Input() isDisabled = false;
  @Input() maxRating;
  @Input() ratingType: RATING_TYPES;
  @Input() ctrl_id: number;
  @Input() ratingValue: number;
  @Input() decreaseRatingSize = false;

  @Output() onRatingChange = new EventEmitter<number>();

  ratingTypes = RATING_TYPES;
  _selectedRating: number = 0;
  _ratings: number[] = [];
  starFontSize: string;
  numberFontSize: string;

  constructor() {}

  get selectedRating(): number {
    return this._selectedRating;
  }

  set selectedRating(value: number) {
    this._selectedRating = value;
  }

  get ratings(): number[] {
    return this._ratings;
  }

  ngOnInit(): void {
    this.selectedRating = +this.ratingValue;

    this.maxRating = this.maxRating ? this.maxRating : DEFAULT_MAX_RATING;
    this.ratingType = this.ratingType ? this.ratingType : DEFAULT_RATING_TYPE;

    this._ratings = Array(+this.maxRating)
      .fill(0)
      .map((x, i) => i + 1);
  }

  ngAfterContentChecked(): void {
    const offsetWidth = this.ratingTemplate?.nativeElement?.parentElement?.offsetWidth;
    this.starFontSize = this.getFontSize('3em', [
      { condition: offsetWidth < 300 && this.decreaseRatingSize, value: '1.1em' },
      { condition: offsetWidth < 500 && this.decreaseRatingSize, value: '2em' },
      { condition: offsetWidth > 500 && this.decreaseRatingSize, value: '3em' },
    ]);
    this.numberFontSize = this.getFontSize('1em', [
      { condition: offsetWidth < 300 && this.decreaseRatingSize, value: '0.35em' },
      { condition: offsetWidth < 500 && this.decreaseRatingSize, value: '0.64em' },
      { condition: offsetWidth > 500 && this.decreaseRatingSize, value: '1em' },
    ]);
  }

  onRating(rating: any): void {
    this.selectedRating = rating;
    this.onRatingChange.emit(this.selectedRating);
  }

  //@ToDo: Check for better solution in future to handle css operation.
  private getFontSize(defaultSize: string, conditions: { condition: boolean; value: string }[]): string {
    for (const { condition, value } of conditions) {
      if (condition) {
        return value;
      }
    }
    return defaultSize;
  }
}
